import React from "react";
import { Button, ButtonGroup } from "@chakra-ui/react";
import { t } from "i18next";
import { UserApi } from "../../../account/services/UserApi";
import { CustomDialog } from "../CustomDialog";

interface Props {
  email: string;
  onConfirm: () => void;
  onClose: () => void;
}
export const UserNotFoundPrompt: React.FC<Props> = ({
  email,
  onClose,
  onConfirm,
}) => {
  return (
    <CustomDialog
      size="md"
      onClose={onClose}
      header={t("account:Users.invitePromptTitle")}
      footer={
        <ButtonGroup colorPalette="primary">
          <Button variant="ghost" onClick={onClose}>
            {t("account:Users.invitePromptCancel")}
          </Button>
          <Button
            onClick={async () => {
              await UserApi.invite({ email });

              onConfirm();
              onClose();
            }}
          >
            {t("account:Users.invitePromptConfirm")}
          </Button>
        </ButtonGroup>
      }
    >
      {t("account:Users.invitePromptBody", { email })}
    </CustomDialog>
  );
};
